import { clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

import sharedConfig from '@repo/tailwind-config/tailwind.config'

import type { ClassValue } from 'clsx'

const customTwMerge = extendTailwindMerge(sharedConfig)

export const cn = (...args: ClassValue[]) => customTwMerge(clsx(...args))
